import http from '../utils/http';
import axios from 'axios';
import i18n from '@/main';

const baseUrl = '/nota-fiscal';

export default {
    async addInvoice(file, data) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('invoice', JSON.stringify(data));
        const url = process.env.VUE_APP_HTTP_PATH + baseUrl + '/inserir-individual';

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    async uploadSpreadsheet(file) {
        const formData = new FormData();
        formData.append('file', file);
        const url = process.env.VUE_APP_HTTP_PATH + baseUrl + '/inserir-lote';

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    cancelar(body) {
        return http.put({
            url: baseUrl + '/cancelar',
            lockScreen: true,
            lockMessage: i18n.t('warehouse.transaction_cancel_modal.processing'),
            data: body
        });
    }
};
